module.exports = __webpack_public_path__ + "assets/highest.aec78948.svg";